import styled from "@emotion/styled";
import { BlockState } from "../types";
import React, { useEffect, useState } from 'react';

interface MazeBlockType {
    blockState: BlockState;
}

interface ColorType {
    color: string;
}
export const MazeBlock: React.FC<MazeBlockType> = ({ blockState }) => {
    const StyledBlock = styled.div`
        background: ${(props: ColorType) => props.color};
        width: 25px;
        height: 25px;
        display: inline-block;
    `
    const [color, setColor] = useState("linear-gradient(to bottom right, white, #cccccc);");
    useEffect(()=>{
        if(blockState === BlockState.Goal){
            setColor("green");
        }else if(blockState === BlockState.Filled){
            setColor("linear-gradient(to bottom right, black, #888888);");
        }else if(blockState === BlockState.Start){
            setColor("blue");
        }
    },[blockState])
    return (
        <StyledBlock color={color}></StyledBlock>
    )



}